import {LoyaltyCardService, OrderService, AuthService} from 'hasta-la-vista-middleware-api/service'
import {LoyaltyCard} from 'hasta-la-vista-middleware-api/model'
import badgeConfig from '../../pages/user/badgeConfig';

export default {
    props: {
        order: Object
    },

    data() {
        return {
            loading: false,
            cards: [],
            // ticketTypes: [],
            newCard: new LoyaltyCard(),
            newCardLoading: false,
            validating: false,
            linkCard: false,
            cardNumberPlaceholder: "Movie Card Number",
            // availableLoyalties: [],
            // rewards: {},
            badgeConfig: badgeConfig,
            rewardSelected: false,
            rewardsList: {},
            showRewards: false,
            outside: undefined,
            fanClubSingle: null,
            fanClubCombo: null,
            allowedSKClubLinkecCards: ["SKCT", "SKC", "SKCS"], // skClub Tuesday, standard and senior
            cinemaType: '',
            defaultTicketType: undefined,
            ticketImageMapping: {
                "loyalty-edgars-club.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('edgars')
                },
                "loyalty-sk-club-premier.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('sk') && ~ticketType.Description.toLowerCase().indexOf('premier')
                },
                "loyalty-sk-club.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('sk')
                },
                "loyalty-vitality.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && !~ticketType.Description.toLowerCase().indexOf('kids')
                },
                "loyalty-vitality-prestige-logo.jpg": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && ~ticketType.Description.toLowerCase().indexOf('prestige')
                },
                "loyalty-vitality-prestige-nouveau-logo.jpg": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && ~ticketType.Description.toLowerCase().indexOf('prestige') && this.cinemaType.includes('Nouveau')
                },
                "loyalty-vitality-kids.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('vitality') && ~ticketType.Description.toLowerCase().indexOf('kids')
                },
                "loyalty-voucher.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('voucher') && !~ticketType.Description.toLowerCase().indexOf('ebucks')
                },
                "loyalty-ebucks.png": (ticketType)=> {
                    return ~ticketType.Description.toLowerCase().indexOf('ebucks')
                },
                "morvies_club_card.png": (ticketType) => {
                    return ~ticketType.Description.toLowerCase().indexOf('morvies')
                },
                "fan_club_card.png": (ticketType) => {
                    return ~ticketType.Description.toLowerCase().indexOf('fan')
                },
            }
        }
    },

    watch: {
        newCard: {
            handler() {


                if (this.newCard.TicketType != undefined) {
                    // console.log(this.newCard.TicketType.Description);
                    if ((this.newCard.TicketType.Description.includes('Voucher') || this.newCard.TicketType.Description.includes('(V)') || this.newCard.TicketType.Description.includes('Re-Admission')) && !this.newCard.TicketType.Description.includes('EBucks')) {
                        this.cardNumberPlaceholder = "Voucher Number"
                    } else {
                        this.cardNumberPlaceholder = "Movie Card Number"
                    }
                } else {
                    this.cardNumberPlaceholder = "Movie Card Number"
                }
            },
            deep: true
        },
    },

    computed: {
        seatNames() {
            return (this.order.Tickets.map((Ticket) => Ticket.SeatData))
        },

        newCardSubmittable(){
            return this.newCard.MemberCard && this.newCard.MemberCard != '' && this.newCard.TicketType != undefined;
        },

        selectedTicketType() {
            return (this.newCard.TicketType != undefined) ? this.newCard.TicketType : null;
        },

        isStandardPackageTicket() {
            if(this.newCard.TicketType != undefined) {
                if(this.newCard.TicketType.IsPackageTicket && !this.newCard.TicketType.IsThirdPartyMemberTicket && !this.newCard.TicketType.IsRedemptionTicket) {
                    return true;
                }
            }

            return false
        },

        ticketTypes(){
            let loyalty = this.order && this.order.TicketTypes ? this.order.TicketTypes.filter((type)=> {
                return type.IsThirdPartyMemberTicket || type.IsRedemptionTicket;
            }) : [];

            let packageTickets = this.order && this.order.TicketTypes ? this.order.TicketTypes.filter((type)=> {
                return !type.IsThirdPartyMemberTicket && !type.IsRedemptionTicket && type.IsPackageTicket == true && !(type.Description.includes("SK Fan Club"));
            }) : [];

            let ticketTypes = loyalty.concat(packageTickets)
            ticketTypes.sort((a,b) => a.DisplaySequence - b.DisplaySequence)

            return ticketTypes
        },

        availableLoyalties(){
            let addedNonStandardTickets = this.addedNonStandardTickets
            let addedTicketTypeCodes = []
            for(let i = 0; i < addedNonStandardTickets.length; i++) {
                addedTicketTypeCodes.push(addedNonStandardTickets[i].TicketTypeCode)
            }

            return this.ticketTypes && this.user ? this.ticketTypes.reduce((c, t)=> {

                if (~this.allowedSKClubLinkecCards.indexOf(t.ThirdPartyMembershipName.split(' ')[0])) {
                    if ((t.ThirdPartyMembershipName.split(' ')[0] == "SKCS" && this.user.MemberLevelId == 3) || (t.ThirdPartyMembershipName.split(' ')[0] != "SKCS" && this.user.MemberLevelId != 3)) {
                        let cardNUmber = this.user.CardNumber;
                        let card = new LoyaltyCard({
                            MemberCard: cardNUmber,
                            TicketType: t,
                            MemberProviderName: this.user.FirstName
                        })
                        card.linked = false;
                        if(addedTicketTypeCodes.includes(t.TicketTypeCode)) card.linked = true
                        c.push(card);
                    }
                }

                if(this.user.PreferenceList.includes(5)) {
                    if(t.Description.includes("SK MORvies") && !t.Description.includes("Combo")) {
                        let cardNUmber = this.user.CardNumber;
                        let card = new LoyaltyCard({
                            MemberCard: cardNUmber,
                            TicketType: t,
                            MemberProviderName: this.user.FirstName
                        })
                        card.linked = false;
                        if(addedTicketTypeCodes.includes(t.TicketTypeCode)) card.linked = true
                        c.push(card);
                    }
                }

                if(this.user.PreferenceList.includes(5)) {
                    if(t.Description.includes("SK MORvies") && t.Description.includes("Combo")) {
                        let cardNUmber = this.user.CardNumber;
                        let card = new LoyaltyCard({
                            MemberCard: cardNUmber,
                            TicketType: t,
                            MemberProviderName: this.user.FirstName
                        })
                        card.linked = false;
                        if(addedTicketTypeCodes.includes(t.TicketTypeCode)) card.linked = true
                        c.push(card);
                    }
                }


                    if(this.user.PreferenceList.includes(6)) {
                        if(t.Description.includes("SK Fan") && !t.Description.includes("Combo")) {
                            let cardNUmber = this.user.CardNumber;
                            let card = new LoyaltyCard({
                                MemberCard: cardNUmber,
                                TicketType: t,
                                MemberProviderName: this.user.FirstName
                            })
                            card.linked = false;
                            if(addedTicketTypeCodes.includes(t.TicketTypeCode)) card.linked = true
                            c.push(card);

                            this.fanClubSingle = card
                        }
                    }

                    if(this.user.PreferenceList.includes(6)) {
                        if(t.Description.includes("SK Fan") && t.Description.includes("Combo")) {
                            let cardNUmber = this.user.CardNumber;
                            let card = new LoyaltyCard({
                                MemberCard: cardNUmber,
                                TicketType: t,
                                MemberProviderName: this.user.FirstName
                            })
                            card.linked = false;
                            if(addedTicketTypeCodes.includes(t.TicketTypeCode)) card.linked = true
                            c.push(card);

                            this.fanClubCombo = card
                        }
                    }

                return c
            }, []) : [];
        },

        rewards(){
            return this.rewardsList && this.rewardsList.TicketTypeList && this.order && this.order.TicketTypes ? this.rewardsList.TicketTypeList.reduce((c, r)=> {
                //console.log("reduce", c, r)
                let TicketType = this.order.TicketTypes.find((t)=> {
                  return t.HeadOfficeGroupingCode == r.VistaID
                });
                if (TicketType) {
                    r.badge = this.getBadgeIcon(r)
                    c.push(Object.assign({}, r, {TicketType}));
                }
                return c;
            }, []) : [];

        },

        fanLoyaltyCountAvailable() {
            let count = 0
            if(this.rewardsList != undefined && this.rewardsList != null) {
                if(this.rewardsList.TicketTypeList != undefined && this.rewardsList.TicketTypeList != null) {
                    for(let i = 0; i <= this.rewardsList.TicketTypeList.length; i++) {
                        // console.log("this.rewardsList.TicketTypeList[i]",this.rewardsList.TicketTypeList[i], i)
                        if(this.rewardsList.TicketTypeList[i] != undefined && this.rewardsList.TicketTypeList[i] != null) {
                            if(this.rewardsList.TicketTypeList[i].Name.includes("Limited Subs")) {
                                if(this.rewardsList.TicketTypeList[i].QtyAvailable > 0) {
                                    count = this.rewardsList.TicketTypeList[i].QtyAvailable
                                }
                            }
                        }
                    }
                }
            }

            return count;
        },

        fanLoyaltyCountAdded() {
            let count = 0

            // console.log("session loyalties",this.order.Session.Loyalties)
            if(this.order.Session.Loyalties != undefined && this.order.Session.Loyalties != null) {
                for(let i = 0; i <= this.order.Session.Loyalties.length; i++) {
                    if(this.order.Session.Loyalties[i] != undefined && this.order.Session.Loyalties[i] != null) {
                       // console.log(this.order.Session.Loyalties[i].TicketType.Description)

                       if(this.order.Session.Loyalties[i].TicketType.Description.includes('Fan Club')) {
                            count++
                       }
                    }


                }
            }

            return count
        },

        addedVoucherTickets() {
            let addedVouchers = []
            if(this.order.Session.Tickets.length > 0) {
                for(let i = 0; i < this.order.Session.Tickets.length; i++) {
                    let ticket = this.order.Session.Tickets[i]

                    //'bundle','voucher','(v)','re-admission','readmission'
                    if(ticket.Barcode !== null &&
                        (
                            ticket.Description.toLowerCase().includes('bundle') ||
                            ticket.Description.toLowerCase().includes('voucher') ||
                            ticket.Description.toLowerCase().includes('(v)') ||
                            ticket.Description.toLowerCase().includes('re-admission') ||
                            ticket.Description.toLowerCase().includes('readmission'))) {
                        addedVouchers.push(ticket)
                    }
                }
            }
            return addedVouchers
        },

        addedLoyaltyTickets() {
            let addedLoyalties = []
            if(this.order.Session.Tickets.length > 0) {
                for(let i = 0; i < this.order.Session.Tickets.length; i++) {
                    let ticket = this.order.Session.Tickets[i]
                    for(let t = 0; t < this.order.Session.TicketTypes.length; t++) {
                        let ticketType = this.order.Session.TicketTypes[t]
                        //console.log(ticketType.TicketTypeCode, ticket.TicketTypeCode, ticket.Description)
                        if(ticketType.TicketTypeCode === ticket.TicketTypeCode &&
                            (
                                ticket.Description.toLowerCase().includes('bundle') === false &&
                                ticket.Description.toLowerCase().includes('voucher') === false &&
                                ticket.Description.toLowerCase().includes('(v)') === false &&
                                ticket.Description.toLowerCase().includes('re-admission') === false &&
                                ticket.Description.toLowerCase().includes('readmission') === false)) {
                            if(ticketType.IsThirdPartyMemberTicket || ticketType.IsRedemptionTicket) {
                                addedLoyalties.push(ticket)
                            } else if(ticketType.LoyaltyRecognitionId !== undefined && ticketType.LoyaltyRecognitionId !== null) {
                                addedLoyalties.push(ticket)
                            }
                        }
                    }

                }
            }
            return addedLoyalties
        },

        addedNonStandardTickets() {
            let addedLoyalties = this.addedLoyaltyTickets
            let addedVouchers = this.addedVoucherTickets
            return addedLoyalties.concat(addedVouchers)
        }
    },

    methods: {
        getBadgeIcon(reward){
            for (var i = 0; i < this.badgeConfig.length; i++) {
                let badgeConfig = this.badgeConfig[i];
                if (badgeConfig.test(reward))
                    return badgeConfig;

            }
        },
        onSubmit() {
            if (this.newCardSubmittable && !this.isStandardPackageTicket) {
                this.validating = true
                this.order._loading = true
                this.loading = true
                //if package ticket and not subsclub and not thirdpart|| redeption
                //do this
                OrderService.validateLoyaltyForOrder(this.newCard).then((ValidCardResponse)=> {

                    if (ValidCardResponse.Barcode) {
                        let updatedOrder = OrderService._processOrder(ValidCardResponse.order)
                        //console.log(this.order.TicketsForSeating)
                        this.order.loadSeatGrid().then(()=> {
                            let tickets = updatedOrder.TicketsForSeating
                            this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            this.loading = false
                            this.order._loading = false
                        });

                        this.newCard.clear();
                        this.validating = false;
                        this.order._loading = false
                    } else {
                        let updatedOrder = OrderService._processOrder(ValidCardResponse.order)
                        this.order.loadSeatGrid().then(()=> {
                            let tickets = updatedOrder.TicketsForSeating
                            this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            this.loading = false
                            this.order._loading = false
                        });

                        this.validating = false;
                    }
                }, (error)=> {
                    this.newCard.Error = (error.error_string || "Unknown Error, Please try again later.")
                    this.validating = false;
                    this.order._loading = false
                    this.loading = false
                });
            }
        },

        deleteCard(card){
            this.rewardSelected = false
            this.order.removeLoyalty(card);
        },

        toggleLoyalty(thisCard){

            if (thisCard.linked) {
                this.validating = true;
                this.order._loading = true;
                this.loading = true;
                OrderService.validateLoyaltyForOrder(thisCard).then((ValidCardResponse)=> {
                    // if the response has sessions, this is not a validated card
                    // instead, its a voucher that has actually added a ticket to the order.
                    // this means that what ever ticket was retrieved needs to be added to unassigned so that it is removed and readded on continue
                    let card = null;

                    if (ValidCardResponse.Barcode) {
                        let updatedOrder = OrderService._processOrder(ValidCardResponse.order)
                        this.order.loadSeatGrid().then(()=> {
                            let tickets = updatedOrder.TicketsForSeating
                            this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            this.loading = false
                            this.order._loading = false
                        });

                        this.newCard.clear();
                        this.validating = false;
                        this.order._loading = false
                        this.loading = false
                    } else {
                        let updatedOrder = OrderService._processOrder(ValidCardResponse.order)
                        this.order.loadSeatGrid().then(()=> {
                            let tickets = updatedOrder.TicketsForSeating
                            this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                            this.loading = false
                            this.order._loading = false
                        });

                        this.newCard.clear();
                        this.validating = false;
                        this.order._loading = false
                        this.loading = false
                    }

                }, (error)=> {
                    // console.log("error", error)
                    if(error.error_string.includes("DB Exception")) {
                        error.error_string = "Unable to validate Loyalty, please try again later."
                    }

                    this.newCard.Error = (error.error_string || "Unable to validate Loyalty, please try again later.");
                    this.validating = false;
                    this.order._loading = false
                    this.loading = false
                    thisCard.linked = false;
                });
            } else {

                let addedLoyaltyTickets = this.addedLoyaltyTickets
                //console.log("toggleRemove Loyalty", thisCard, this.addedLoyaltyTickets)
                let ticketTypeCode = thisCard.TicketType.TicketTypeCode
                let removeTicket = null
                for(let i = 0; i < addedLoyaltyTickets.length; i++) {
                    if(addedLoyaltyTickets[i].TicketTypeCode == ticketTypeCode) {
                        removeTicket = addedLoyaltyTickets[i]
                    }
                }
                //console.log("toggleRemove Loyalty", removeTicket)
                return this.deleteVistaLoyaltyTicket(removeTicket)
            }
        },

        toggelReward(thisCard, originalTicket) {
            console.log("toggelReward", thisCard, originalTicket)

            this.validating = true;
            this.order._loading = true;
            this.loading = true;

            OrderService.toggleRewardForOrder(thisCard, originalTicket).then((ValidCardResponse)=> {
                // if the response has sessions, this is not a validated card
                // instead, its a voucher that has actually added a ticket to the order.
                // this means that what ever ticket was retrieved needs to be added to unassigned so that it is removed and readded on continue
                let card = null;

                let updatedOrder = OrderService._processOrder(ValidCardResponse)
                this.order.loadSeatGrid().then(()=> {
                    let tickets = updatedOrder.TicketsForSeating
                    this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                    this.loading = false
                    this.order._loading = false
                });

                this.newCard.clear();
                this.validating = false;
                this.order._loading = false
                this.loading = false

            }, (error)=> {
                // console.log("error", error)
                if(error.error_string.includes("DB Exception")) {
                  error.error_string = "Unable to validate Loyalty, please try again later."
                }

                this.newCard.Error = (error.error_string || "Unable to validate Loyalty, please try again later.");
                this.validating = false;
                this.order._loading = false
                this.loading = false
                thisCard.linked = false;
            });
        },

        toggleFanLoyalty(thisCard){

                this.validating = true;
                OrderService.validateLoyaltyForOrder(thisCard).then((ValidCardResponse)=> {
                    // if the response has sessions, this is not a validated card
                    // instead, its a voucher that has actually added a ticket to the order.
                    // this means that what ever ticket was retrieved needs to be added to unassigned so that it is removed and readded on continue
                    let card = null;

                    if (ValidCardResponse.Barcode) {
                        card = Object.assign(ValidCardResponse, {
                            TicketType: thisCard.TicketType,
                            MemberProviderName: thisCard.Name,
                            Barcode: ValidCardResponse.Barcode,
                            Name: thisCard.Name
                        });
                    } else {
                        card = Object.assign(ValidCardResponse, {
                            TicketType: thisCard.TicketType,
                            MemberProviderName: thisCard.Name,
                            MemberCard: ValidCardResponse.CardNumber,
                            Name: thisCard.Name
                        });
                    }

                    // console.log("addLoyalty", card)
                    this.order.addLoyalty(card);
                    this.validating = false;
                }, (error)=> {
                    this.newCard.Error = (error.error_string || "Unknown Error, Please try again later.")
                    this.validating = false;
                    thisCard.linked = false;
                });

        },

        toggleRewards($e){
            $e.stopImmediatePropagation()
            this.showRewards = !this.showRewards;
            if (this.showRewards && this.outside) {
                this.outside._click = this.toggleRewards;
                this.outside.addEventListener("click", this.toggleRewards)

            } else if (this.outside) {
                this.outside.removeEventListener("click", this.outside._click)
            }


        },

        addReward(reward, card){
            card.RecognitionID = reward.RecognitionID;
            card.SequenceNumber = reward.SequenceNumber;
            card.TicketType = reward.TicketType;
            this.rewardSelected = true
            // OrderService.validateLoyaltyForOrder(new LoyaltyCard(card))
        },

        getLoyalty(ticketType){
            let uri = '/static/img/'
            let img = 'loyalty-voucher.png';
            for (let i = 0; i < Object.keys(this.ticketImageMapping).length; i++) {
                let key = Object.keys(this.ticketImageMapping)[i];
                if (this.ticketImageMapping[key](ticketType))
                    img = key;
            }
            return uri + img;
        },

        isNouveau(order) {
            order.Session.MoviePromise.then(() => {
                order.Experiences.forEach((exp) => {
                    if (exp && exp.name.includes('Nouveau')) this.cinemaType = exp.name
                })
            })
        },

        deleteVistaVoucherTicket(ticket) {
            this.loading = true
            this.order._loading = true
            OrderService.removeVistaVoucherTicket(this.order.SessionId, this.order.CinemaId, ticket).then(order => {
                let updatedOrder = OrderService._processOrder(order)
                this.order.loadSeatGrid().then(()=> {
                    let tickets = updatedOrder.TicketsForSeating
                    //console.log("TicketsForSeating", tickets)
                    this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                    this.loading = false
                    this.order._loading = false
                });
            })
        },

        deleteVistaLoyaltyTicket(ticket) {
            this.loading = true
            this.order._loading = true
            OrderService.removeVistaLoyaltyTicket(this.order.SessionId, this.order.CinemaId, ticket).then(order => {
                let updatedOrder = OrderService._processOrder(order)
                this.order.loadSeatGrid().then(()=> {
                    let tickets = updatedOrder.TicketsForSeating
                    this.order.Session.SeatGrid.mapTicketsToGrid(tickets);
                    this.loading = false
                    this.order._loading = false
                });
            })
        }

    },

    beforeDestroy(){
        if (this.outside && this.outside._click) {
            this.outside.removeEventListener("click", this.outside._click)
        }
    },

    created() {
        this.loading = true;
        this.outside = document.getElementById('app') || document.body;



        Promise.all([AuthService.user(), AuthService.getRewards()]).then(([user,rewards])=> {
            this.user = user;
            this.rewardsList = rewards;
            this.isNouveau(this.order)

            this.loading = false;
        });
    },

}



// WEBPACK FOOTER //
// ./src/components/booking/loyalty/loyalty.js